/**
 * Replace dynamic Gatsby template path segments with placeholders so URL
 * cardinality stays bounded in the analytics dashboard.
 *
 * Keep this in sync with `gatsby-node.ts#createPages` — every dynamic route
 * registered there needs a rule here.
 */
const RULES: Array<{ test: RegExp; replace: string }> = [
  { test: /^\/guias\/[^/]+\/?$/, replace: "/guias/:slug" },
];

export function scrubPath(pathname: string): string {
  for (const rule of RULES) {
    if (rule.test.test(pathname)) return rule.replace;
  }
  return pathname;
}
